// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`RadioItem test Match con el snapshot 1`] = `<div class="input-container"><input type="radio" name="radio-0" id="option-undefined" value=""> <label for="option-undefined"></label></div>`;
